// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./src/app.js");
__webpack_require__("./node_modules/webpack-dev-server/client/index.js?http://0.0.0.0:13002");
var __webpack_exports__ = __webpack_require__("./node_modules/webpack/hot/only-dev-server.js");
